import React, { useState } from 'react';

import { Col, Modal } from 'react-bootstrap';
import '../JobStageSummary.scss';
import { CustomButton } from '../../../_common/CustomButton/CustomButton';
import { Loading } from '../../../_common/Loading/Loading';
import { GetStageSheet_getStageSheet_details as StageSheet } from '../../../../types/schemaTypes';
import { blockInvalidChar } from '../../../_common/blockInvalidChar';

interface StageSheetEditLoadWeightModalProps {
    jobId: number;
    showModal: boolean;
    stageSheet: StageSheet;
    handleOnClose: () => void;
    handleOnSave: (
        boxId: number,
        loadId: number,
        inventoryWeight: number,
        oldInventoryWeight: number,
        stageSheetBoxId: number,
    ) => void;
    mutationLoading: boolean;
    mutationError: string | undefined;
}

const StageSheetEditLoadWeightModal = ({
    jobId,
    showModal,
    stageSheet,
    handleOnClose,
    handleOnSave,
    mutationLoading,
    mutationError,
}: StageSheetEditLoadWeightModalProps): React.ReactElement => {
    const [inventoryWeight, setInventoryWeight] = useState(stageSheet.loadWeight);

    const onChangeInventoryWeight = value => {
        setInventoryWeight(value);
    };
    const onClickSave = () => {
        handleOnSave(
            stageSheet.boxId ?? 0,
            stageSheet.loadId ?? 0,
            inventoryWeight ?? 0,
            stageSheet.loadWeight ?? 0,
            stageSheet.stageSheetBoxId ?? 0,
        );
    };
    const onClickClose = () => {
        handleOnClose();
    };

    return (
        <Modal show={showModal} onHide={onClickClose} dialogClassName="StageModal-Container">
            {mutationLoading && (
                <span className="AddStageModal-Loading">
                    <Loading />
                </span>
            )}

            <Modal.Header className="AddStageModal-Header">
                <Modal.Title className="AddStageModal-Header-Container">
                    <button className="material-icons AddStageModal-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="AddStageModal-Title">Edit Delivered Weight</div>
                    <div className="AddStageModal-Error">{mutationError}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="AddStageModal-Body">
                <Col md={10}>
                    <div className="StageSheet-Delete-Header">
                        Are you sure you want to edit the delivered weight of the box - {stageSheet.boxDesc}?
                    </div>
                    <div className="StageSheet-Modal-LoadWeight-Container">
                        <label className="StageSheet-Modal-LoadWeight-Label">Delivered Weight</label>
                        <input
                            type="number"
                            className="StageSheet-Modal-LoadWeight-Input"
                            onKeyDown={blockInvalidChar}
                            value={inventoryWeight ?? ''}
                            onChange={event => onChangeInventoryWeight(parseInt(event.target.value))}
                        />
                    </div>
                </Col>
            </Modal.Body>

            <Modal.Footer className="AddStageModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                <CustomButton
                    title="Continue"
                    isDisabled={mutationLoading || (!inventoryWeight && inventoryWeight !== 0)}
                    onClick={() => onClickSave()}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default StageSheetEditLoadWeightModal;
